<template>

	<div>
		<Layout :mastheadBackgroundImage="bgImages.masthead">
			<template slot="headline"></template>
			<!-- <template slot="header">
				<ImageHeader :header1BackgroundImage="bgImages.header1" :header2BackgroundImage="bgImages.header2" :header3BackgroundImage="bgImages.header3" />
			</template> -->
			<template slot="body">
				<AboutIntro />
			</template>
		</Layout>
		<FooterCTA />
	</div>

</template>

<script>
	import Layout from '@/components/OurCompany/layout'
	import AboutIntro from '@/components/OurCompany/AboutIntro'
	import AboutIntro1 from '@/components/OurCompany/AboutIntro1'
	import ImageText from '@/components/OurCompany/ImageText'
	import ImageGrid from '@/components/OurCompany/ImageGrid'
	import FooterCTA from '@/components/FooterCTA'

	export default {
		metaInfo: {
			title: "StudySync Company"
		},
		components: { Layout, AboutIntro, AboutIntro1, ImageText, ImageGrid, FooterCTA },
		data () {
			return {
				bgImages: {
					masthead: require('@/assets/img/mastheads/company.jpg'),
					header1: require('@/assets/img/about/header1.jpg'),
					header2: require('@/assets/img/about/header2.jpg'),
					header3: require('@/assets/img/about/header3.jpg'),
					careers: require('@/assets/img/about/careers.jpg'),
					authors: require('@/assets/img/about/header4.jpg'),
					office: require('@/assets/img/about/office1.jpg')
				},
				theBoys: require('@/assets/img/the-boys2.jpg'),
				team: [
					// Should always be multiple of four!
					{
						name: "Robert Romano",
						title: "Co-Founder and CEO",
						image: require('@/assets/img/team/robert_1000.jpg'),
						url: 'https://www.linkedin.com/in/robert-romano-3369782a/'
					}, // 1
					{
						name: "Jay King",
						title: "Co-Founder and Chief Operating Officer",
						image: require('@/assets/img/team/jay_1000.jpg'),
						url: 'https://www.linkedin.com/in/johnjkingiii/'
					}, // 2
					{
						name: "Leah Osterman",
						title: "Chief Marketing Officer",
						image: require('@/assets/img/team/leah_1000.jpg'),
						url: 'https://www.linkedin.com/in/leahosterman/'
					}, // 3
					{
						name: "Brad McCord",
						title: "Chief Financial Officer",
						image: require('@/assets/img/team/brad_1000.jpg'),
						url: 'https://www.linkedin.com/in/bradley-t-mccord-8676742/'
					}, // 4
					{
						name: "Brian Canning",
						title: "Chief Technology Officer",
						image: require('@/assets/img/team/brian_1000.jpg'),
						url: 'https://www.linkedin.com/in/briancanning/'
					}, // 5
					{
						name: "Ryan Bubalo",
						title: "Senior Vice President, Curriculum",
						image: require('@/assets/img/team/ryan_1000.jpg'),
						url: 'https://www.linkedin.com/in/ryanmbubalo/'
					} // 6
					// {
					// 	name: "Cyndi Smith",
					// 	title: "VP, International Business Development at StudySync",
					// 	image: require('@/assets/img/team/cyndi_1000_1.jpg'),
					// 	url: 'https://www.linkedin.com/in/cyndi-smith-b592376/'
					// }, // 7
					// {
					// 	name: "Mark Dwyer",
					// 	title: "Creative Consultant",
					// 	image: require('@/assets/img/team/dwyer_1000_2.jpg'),
					// 	url: 'http://dwyerproductions.com/'
					// } // 8
				],
				partners: [
					// Should always be multiple of 3!
					{
						name: "McGraw Hill",
						description: "The science of learning drives everything they do at McGraw Hill. By combining this expertise with innovative thinking and new emerging technologies we’re able to combine content and technology in a way that is seamless, elegant, and deeply personalized for each student – providing a more relevant and meaningful learning experience.",
						image: require('@/assets/img/partners/mcgraw2.jpg'),
						url: 'https://www.mheducation.com/prek-12/program/microsites/MKTSP-ROA01M0'
					}, // 1
					// {
					// 	name: "Reuters",
					// 	description: "Since 1850, Reuters have experimented, invented, and created content and news solutions to become the world’s leading international news agency. Always at the forefront of real-time breaking news and high-impact global multimedia content, Reuters is constantly innovating their products and services to meet their client's business needs.",
					// 	image: require('@/assets/img/partners/reuters1.jpg'),
					// 	url: 'https://www.reuters.com/'
					// }, // 2
					// {
					// 	name: "The Players' Tribune",
					// 	description: "The Players' Tribune is a new media company that provides athletes with a platform to connect directly with their fans, in their own words. Founded by Derek Jeter, The Players’ Tribune publishes first-person stories from athletes, providing unique insight into the daily sports conversation. Through impactful and powerful long- and short-form stories, video series and podcasts, The Players’ Tribune brings fans closer than ever to the games they love.",
					// 	image: require('@/assets/img/partners/players1.jpg'),
					// 	url: 'https://www.theplayerstribune.com/en-us'
					// }, // 3
					{
						name: "The News Literacy Project",
						description: "The News Literacy Project is a national education nonprofit offering nonpartisan, independent programs that teach students how to know what to believe in the digital age. The News Literacy Project, a nonpartisan national education nonprofit, empowers educators to teach students the skills they need to become smart, active consumers of news and information and engaged, informed participants in our democracy.",
						image: require('@/assets/img/partners/literacy1.jpg'),
						url: 'https://newslit.org/'
					}, // 4
					{
						name: "NTROPIC",
						description: "NTROPIC produces beautiful visual content for every medium — but that’s not what makes them unique. What makes them unique is their intuition: knowing how to generate ideas that can penetrate an oversaturated market and knowing how to take their clients to the finish line, thinking creatively to solve challenges at every stage. Most of all, NTROPIC cares about getting it right.",
						image: require('@/assets/img/partners/ntropic1.jpg'),
						url: 'http://www.ntropic.com'
					} // 5
					// {
					// 	name: "LeStoury Academy",
					// 	description: "LeStoury Academy is an educational services provider in China, with its R&D hub in New Zealand and the US. LeStoury is devoted to bringing quality customized curriculum, and educational products and services, to its business partners all around the globe. LeStoury has provided educational solutions for major organizations in the Chinese market including New Oriental, TAL Group, VIPKID, NetEase, and Vanke Education.",
					// 	image: require('@/assets/img/partners/lestoury.jpg'),
					// 	url: 'http://www.lestoury.com/'
					// }, // 6
					//{
					//	name: "Global Press Journal",
					//	description: "Global Press Journal exists to create a more just and informed world by training and employing local female journalists to produce ethical, accurate news coverage from the world’s least-covered places. Global Press prioritizes the physical and cognitive diversity of their team. They believe the journalism institutions have a responsibility to pursue diversity to ensure that the people and places they are covering are accurately represented.",
					//	image: require('@/assets/img/partners/global1.jpg'),
					//	url: 'https://globalpressjournal.com/'
					//}, // 7
				]
			}
		}
	}

</script>

<style lang="scss" scoped>
	.image-grid-spacing {
		margin-top:8.5rem;
	}
	.in-page-image {
		img {
			display:block; max-width:none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/routes/our-company/index.vue